import React, { Fragment, useContext, useState } from 'react'
import { AuthenticationContext } from '../../Auth/authentication.context'
import AuthLayout from '../Layout/AuthLayout'

import { ToastPopUp } from '../shared/utils'
import {
  Form,
  FormFeedback,
  Label,
  Input,
  Card,
  InputGroup,
  InputGroupText,
} from 'reactstrap'

// Formik validation
import * as Yup from 'yup'
import { useFormik } from 'formik'

import { Link, useSearchParams, Navigate } from 'react-router-dom'

import AuthFormsLayout from '../Layout/AuthFormsLayout'

const CreatePassword = (props) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
    
  }
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword)

  }
  const { onVerify, user, error } = useContext(AuthenticationContext)
  //
  const [searchParams, setSearchParams] = useSearchParams()
  const id = searchParams.get('id')

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .matches(
          passwordRegex,
          'Password must contain: minimum 8 characters, at least one uppercase letter, at least one lowercase letter, at least one number, and at least one special character (@ $ ! % * # ? &)'
        )
        .required('Please Enter Your Password'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Required'),
    }),
    onSubmit: (values) => {
      onVerify(id, values.password, values.confirmPassword)
    },
  })

  const passwordValue = validation.values.password || ''
  const passwordRules = {
    minLength: passwordValue.length >= 8,
    hasLowercase: /[a-z]/.test(passwordValue),
    hasUppercase: /[A-Z]/.test(passwordValue),
    hasNumber: /\d/.test(passwordValue),
    hasSpecial: /[@$!%*#?&]/.test(passwordValue),
  }

  const renderRule = (met, label) => (
    <div
      className={`d-flex align-items-center ${met ? 'text-success' : 'text-danger'}`}
    >
      <i
        className={`mdi ${met ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'} me-1`}
      />
      <span>{label}</span>
    </div>
  )

  // handleValidSubmit
  // const handleValidSubmit = (event, values) => {
  //   props.registerUser(values);
  // };

  document.title = 'Create Password | Origins Direct'
  return (
    <>
      <AuthLayout>
        <Card className='p-4'>
          <h2 className='text-center'>Create Password</h2>
          <h3 className='text-center'>
            Get your Origins Direct account now
          </h3>
          {user ? (
            <Navigate to='/' />
          ) : (
            <>
              {/* <AuthFormsLayout
            title='Create Password'
            subtitle='Get your free Origins Direct account now.'
          > */}

              <Form
                className='mt-4'
                onSubmit={(e) => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
                action='#'
              >
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className='mb-3'>
                  <InputGroup>
                    <Input
                      name='password'
                      value={validation.values.password || ''}
                      type={showPassword ? 'text' : 'password'}
                      className='form-control'
                      placeholder='Enter Password'
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password &&
                        !!validation.errors.password
                      }
                    />
                    <InputGroupText
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    >
                      <i
                        className={`mdi ${
                          showPassword
                            ? 'mdi-eye-off-outline'
                            : 'mdi-eye-outline'
                        }`}
                      ></i>
                    </InputGroupText>
                  </InputGroup>

                  {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type='invalid'>
                      {validation.errors.password}
                    </FormFeedback>
                  ) : null}

                  {/* Inline password requirements helper */}
                  {(validation.touched.password || passwordValue.length > 0) && (
                    <div className='mt-2 small'>
                      <div className='text-muted mb-1'>
                        Password must include:
                      </div>
                      {renderRule(passwordRules.minLength, 'At least 8 characters')}
                      {renderRule(
                        passwordRules.hasUppercase,
                        'At least 1 uppercase letter (A-Z)'
                      )}
                      {renderRule(
                        passwordRules.hasLowercase,
                        'At least 1 lowercase letter (a-z)'
                      )}
                      {renderRule(
                        passwordRules.hasNumber,
                        'At least 1 number (0-9)'
                      )}
                      {renderRule(
                        passwordRules.hasSpecial,
                        'At least 1 special character (@ $ ! % * # ? &)'
                      )}
                    </div>
                  )}
                </div>

                <div className='mb-3'>
                  <InputGroup>
                    <Input
                      name='confirmPassword'
                      value={validation.values.confirmPassword || ''}
                      type={showConfirmPassword ? 'text' : 'password'}
                      id='confirmPassword'
                      className='form-control'
                      placeholder='Repeat Password'
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.confirmPassword &&
                        validation.errors.confirmPassword
                          ? true
                          : false
                      }
                    />
                    <InputGroupText
                      onClick={toggleConfirmPasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    >
                      <i
                        className={`mdi ${
                          showConfirmPassword
                            ? 'mdi-eye-off-outline'
                            : 'mdi-eye-outline'
                        }`}
                      ></i>
                    </InputGroupText>
                  </InputGroup>
                  {validation.touched.confirmPassword &&
                  validation.errors.confirmPassword ? (
                    <FormFeedback type='invalid'>
                      {validation.errors.confirmPassword}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className='mb-3 row'>
                  <div className='col-12 text-end'>
                    <button
                      className='btn btn-primary w-md waves-effect waves-light'
                      type='submit'
                    >
                      Save & Login
                    </button>
                  </div>
                </div>
              </Form>
              {/* </AuthFormsLayout> */}

              <div className='mt-4 text-center'>
                <div className='line-divider'>
                  <div className='line'></div>
                  <span>Already have an account ?</span>
                  <div className='line'></div>
                </div>
                <Link to='/login'>
                  <button className='create-account-btn'>Login Now</button>
                </Link>
              </div>
              {/* <LoggedOutFooter /> */}
            </>
          )}
        </Card>
      </AuthLayout>
    </>
  )
}

export default CreatePassword
